export const distributionOption = [
    {
        type: 'centOS',
        user: 'centos'
    },
    {
        type: 'ubuntu',
        user: 'ubuntu'
    },
    {
        type: 'fedora',
        user: 'fedora'
    },
    {
        type: 'opensuse leap',
        user: 'opensuse'
    },
    {
        type: 'debian',
        user: 'debian'
    }
];

export const appStack = [
    {
        key: 'mysql',
        value: {
            name: 'MySQL',
            version: 'OS ubuntu 20.04',
            heading: 'MYSQL Server',
            headingDesc: 'The world\'s most popular open source database',
            packages: [
                {
                    name: 'MySQL server',
                    version: '8.0.26',
                    verHref: 'https://packages.ubuntu.com/focal/mysql-server',
                    lisHref: 'https://www.mysql.com/about/legal/licensing/oem/#5',
                    licesnse: 'GPL 2 with modifications'
                },
                {
                    name: 'Apache',
                    version: '2.4.41',
                    verHref: 'https://packages.ubuntu.com/focal/apache2',
                    lisHref: 'https://www.apache.org/licenses/',
                    licesnse: 'Apache 2'
                },
                {
                    name: 'PHP',
                    version: '7.4.3',
                    verHref: 'https://packages.ubuntu.com/focal/php',
                    lisHref: 'https://www.php.net/license/index.php',
                    licesnse: 'PHP License v3.01'
                },
                {
                    name: 'phpMyAdmin',
                    version: '4.9.5',
                    verHref: 'https://launchpad.net/ubuntu/+source/ufw/0.36-6',
                    lisHref: 'https://www.phpmyadmin.net/license/',
                    licesnse: 'GPL 2'
                },
                {
                    name: 'UFW',
                    version: '0.36',
                    verHref: 'https://launchpad.net/ubuntu/+source/ufw/0.36-6',
                    lisHref: '',
                    licesnse: ''
                }
            ],
            heading1: 'In addition to the package installation, the MySQL stack image will also',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Enables the UFW firewall to allow only SSH (port 22), HTTP (port 80), HTTPS (port 443) access, and MySQL (3306) access' } },
                { desc: { 'key': 'Creates a new user named <b>admin</b> and sets the password for this user which is available in /root/.idrive_password inside the instance.' } },
                {
                    desc: {
                        'key': 'runs <b>mysql_secure_installation</b>.'
                    }
                },
                {
                    desc: {
                        'key': 'You can access phpMyAdmin immediately by visiting the instance’s IP address in your browser followed by <b>/phpmyadmin</b>'
                    }
                }
            ]
        }
    },
    {
        key: 'lemp',
        value: {
            name: 'LEMP',
            version: 'OS ubuntu 20.04',
            heading: 'LEMP',
            headingDesc: 'LEMP is a variation of the ubiquitous LAMP stack used for developing and deploying web applications. Traditionally, LAMP consists of Linux, Apache, MySQL, and PHP. Due to its modular nature, the components can easily be swapped out. With LEMP, Apache is replaced with the lightweight yet powerful Nginx.',
            packages: [
                {
                    name: 'Nginx',
                    version: '1.18.0',
                    verHref: 'https://packages.ubuntu.com/focal/nginx',
                    lisHref: 'http://nginx.org/LICENSE',
                    licesnse: 'Custom'
                },
                {
                    name: 'MySQL server',
                    version: '8.0.26',
                    verHref: 'https://packages.ubuntu.com/focal/mysql-server',
                    lisHref: 'https://www.mysql.com/about/legal/licensing/oem/#5',
                    licesnse: 'GPL 2 with modifications'
                },
                {
                    name: 'PHP',
                    version: '7.4.3',
                    verHref: 'https://packages.ubuntu.com/focal/php',
                    lisHref: 'https://www.php.net/license/index.php',
                    licesnse: 'PHP License v3.01'
                },
                {
                    name: 'UFW',
                    version: '0.36',
                    verHref: 'https://launchpad.net/ubuntu/+source/ufw/0.36-6',
                    lisHref: '',
                    licesnse: ''
                }
            ],
            heading1: 'In addition to the package installation, the LEMP stack image will also',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Enables the UFW firewall to allow only SSH (port 22), HTTP (port 80), HTTPS (port 443) access, and MySQL (3306) access' } },
                { desc: { 'key': 'Creates a new admin user and sets the password. The MySQL admin user password is in <b>/root/.idrive_password</b> inside the instance. Here the username is <b>admin</b>.' } },
                { desc: { 'key': 'runs <b>mysql_secure_installation</b>.' } }
            ]
        }
    },
    {
        key: 'docker',
        value: {
            name: 'Docker',
            version: 'OS ubuntu 20.04',
            heading: 'Docker',
            headingDesc: 'Docker is a set of platform as a service products that use OS-level virtualization to deliver software in packages called containers. A Docker container image is a lightweight, standalone, executable package of software that includes everything needed to run an application: code, runtime, system tools, system libraries, and settings.',
            packages: [
                {
                    name: 'Docker CE',
                    version: '20.10.7',
                    verHref: 'https://docs.docker.com/engine/release-notes/',
                    lisHref: 'https://github.com/moby/moby/blob/master/LICENSE',
                    licesnse: 'Apache 2'
                },
                {
                    name: 'Docker Compose',
                    version: '1.29.2',
                    verHref: 'https://docs.docker.com/compose/release-notes/',
                    lisHref: 'https://github.com/moby/moby/blob/master/LICENSE',
                    licesnse: 'Apache 2'
                }
            ],
            heading1: 'More info',
            heading1Desc: [],
            heading2Desc: [
                { desc: 'https://www.docker.com/' },
                { desc: 'https://docs.docker.com/compose/' }
            ]
        }
    },
    {
        key: 'jenkins',
        value: {
            name: 'Jenkins',
            version: 'OS ubuntu 20.04',
            heading: 'Jenkins',
            headingDesc: 'Jenkins is an open-source automation tool that can build, test, and deploy your infrastructure. A tool that gives you access to a massive library of plugins to support automation in your project\'s lifecycle.',
            packages: [],
            heading1: 'More info',
            heading2Desc: [{ desc: 'https://jenkins.io/' }],
            heading1Desc: [
                { desc: { 'key': 'Once the instance is created, go to <b>http://[your-instance\'s-ip-address]:8080</b> in a browser to finish the configuration' } },
                { desc: { 'key': 'You will need to SSH into your instance to retrieve the Jenkins one time password: <b>sudo cat /var/lib/jenkins/secrets/initialAdminPassword</b>.' } }
            ]
        }
    },
    {
        key: 'lamp',
        value: {
            name: 'LAMP',
            version: 'OS ubuntu 20.04',
            heading: 'LAMP',
            headingDesc: 'LAMP stands for Linux, Apache, MySQL, and PHP. Together, they provide a proven set of software for delivering high-performance web applications. Each component contributes essential capabilities to the stack:',
            packages: [
                {
                    name: 'MySQL server',
                    version: '8.0.26',
                    verHref: 'https://packages.ubuntu.com/focal/mysql-server',
                    lisHref: 'https://www.mysql.com/about/legal/licensing/oem/#5',
                    licesnse: 'GPL 2 with modifications'
                },
                {
                    name: 'Apache',
                    version: '2.4.41',
                    verHref: 'https://packages.ubuntu.com/focal/apache2',
                    lisHref: 'https://www.apache.org/licenses/',
                    licesnse: 'Apache 2'
                },
                {
                    name: 'PHP',
                    version: '7.4.3',
                    verHref: 'https://packages.ubuntu.com/focal/php',
                    lisHref: 'https://www.php.net/license/index.php',
                    licesnse: 'PHP License v3.01'
                },
                {
                    name: 'phpMyAdmin',
                    version: '4.9.5',
                    verHref: 'https://packages.ubuntu.com/focal/php',
                    lisHref: 'https://www.php.net/license/index.php',
                    licesnse: 'GPL 2'
                },
                {
                    name: 'UFW',
                    version: '0.36',
                    verHref: 'https://launchpad.net/ubuntu/+source/ufw/0.36-6',
                    lisHref: '',
                    licesnse: ''
                }
            ],
            heading1: 'In addition to the package insalltion, the LAMP stack images will also',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Enables the UFW firewall to allow only SSH (port 22), HTTP (port 80), and HTTPS (port 443) access.' } },
                { desc: { 'key': 'Creates a new admin user and sets the password. The MySQL admin user password is in <b>/root/.idrive_password </b> inside the instnce.' } },
                { desc: { 'key': 'runs <b>mysql_secure_installation</b>.' } }
            ]
        }
    },
    {
        key: 'minecraft',
        value: {
            css: 'minecraft',
            name: 'Minecraft',
            version: 'OS ubuntu 20.04',
            heading: 'Minecraft',
            headingDesc: 'With more than 112 million monthly active players, Minecraft is one of the largest online gaming communities. The popular sandbox game provides much to explore, design, and create.',
            packages: [
                {
                    name: 'Minecraft:Java Edition Server',
                    version: '1.17.1',
                    verHref: 'https://www.minecraft.net/en-us/download/server',
                    lisHref: 'https://account.mojang.com/terms',
                    licesnse: 'Minecraft End User License Agreement'
                }
            ],
            heading1: 'After deploying a new Minecraft instance, in the Minecraft desktop application, go to the multiplayer settings and set up the server address.',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Copy the public ipv4 address from the newly created instance from the web console.' } },
                { desc: { 'key': 'Launch the Minecraft application, click <b>Play > Multiplayer</b>.' } },
                { desc: { 'key': 'Click <b>Add Server</b>.' } },
                { desc: { 'key': 'Enter the IP address of the instance in the <b>Server Address field</b>.' } },
                { desc: { 'key': 'Click <b>Done</b>.' } },
                { desc: { 'key': 'Click <b>Join Server</b>.' } },
            ]
        }
    },
    {
        key: 'django',
        value: {
            css: 'django',
            name: 'Django',
            version: 'OS ubuntu 20.04',
            heading: 'Django',
            headingDesc: 'Django is a free and open-source Python-based web framework. It follows the model–template– views architectural pattern and allows rapid development.',
            packages: [
                {
                    name: 'Django',
                    version: '2.2.12',
                    licesnse: 'Custom'
                },
                {
                    name: 'Postgres',
                    version: '12',
                    licesnse: 'Postgres SQL'
                },
                {
                    name: 'Gunicorn',
                    version: '20.0.4',
                    licesnse: 'MIT'
                },
                {
                    name: 'Nginx',
                    version: '1.18.0',
                    licesnse: 'Custom'
                }
            ],
            heading1: 'In addition to the package installation, the Django stack image will also:',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Create a <b>Django helloworld</b> application. After an instance is created, you can use its public IPv4 address to see the <b>helloworld</b> application live. The application will be located in the <b>/home/django/helloworld/</b> directory.' } },
                { desc: { 'key': 'Enable the UFW firewall to allow only SSH (port 22), HTTP (port 80), and HTTPS (port 443) access.' } }
            ],
            heading3: 'Run the Django application',
            heading3Desc: [
                { desc: { 'key': 'Clone the Django code wherever you want.' } },
                { desc: { 'key': 'Create database users according to your requirement.' } },
                { desc: { 'key': 'Edit Gunicorn\'s configuration and point it to <b>/etc/systemd/system/gunicorn.service<b>.' } },
                { desc: { 'key': 'Update Nginx by editing <b>/etc/nginx/sites-enabled/default</b>.' } }
            ]
        }
    },
    {
        key: 'openvpn',
        value: {
            css: 'openVpn',
            name: 'OpenVPN Access Server',
            version: 'OS ubuntu 20.04',
            heading: 'OpenVPN Access Server',
            headingDesc: 'OpenVPN Access Server package comprises a set of installation and configuration tools that simplify the deployment of a VPN remote access solution. As it is based on the popular OpenVPN open-source software project, the package makes the deployed VPN compatible with OpenVPN client software, across multiple platforms and devices. While the open-source solution requires a high degree of knowledge regarding all the configuration options possible with the software, the OpenVPN Access Server offers a web-based graphical interface that is easy-to-use. It also comes with a built-in set of installer file for OpenVPN Connect Client, the client software used to connect Windows and Macs to an OpenVPN Access Server, and these come preconfigured for use immediately after installation.',
            packages: [
                {
                    name: 'OpenVPN',
                    version: '2.10.1',
                    licesnse: 'Custom',
                    lisHref: 'https://openvpn.net/license/',
                },
                {
                    name: 'wget',
                    version: '1.20.3',
                    licesnse: 'GPL',
                    lisHref: 'https://www.gnu.org/licenses/gpl-3.0.html'
                },
                {
                    name: 'gnupg',
                    version: '2.2.19',
                    licesnse: 'GPL',
                    lisHref: 'https://github.com/isislovecruft/python-gnupg/blob/master/LICENSE'
                }
            ],
            heading1: 'Deployment steps:',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': ' Open the address of your server in a web browser, e,g., https://{IP Address of your instance}/admin.' } },
                { desc: { 'key': 'Ignore any SSL certificate warnings and proceed further.' } },
                { desc: { 'key': 'Authenticate with <b>username: openvpn</b> and the password.' } },
                { desc: { 'key': 'Password is stored in the file <b>/root/.idrive_password</b>.' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: 'You can now start using the OpenVPN server.<br>Refer the <a href="https://openvpn.net/community-resources/how-to/" target="_blank">starter&rsquo;s documentation.</a><br><br><p class="info_txt"><strong>Note:</strong><br>When the OpenVPN Access Server is installed without a license key it allows only 2 simultaneous VPN connections. There is no time limit or functionality limit on this mode.</p>'
        }
    },
    {
        key: 'wordpress',
        value: {
            css: 'wordpress',
            name: 'Wordpress Server',
            version: 'OS ubuntu 20.04',
            heading: 'Wordpress',
            headingDesc: 'WordPress is a free and open-source content management system (CMS) with a plugin architecture and customizable Themes. The PHP based platform is usually paired with a MySQL or MariaDB database and was originally designed for publishing blogs. Since then it has evolved into one of the most popular CMS solution used for publishing websites, forums, online stores and more.',
            packages: [
                {
                    name: 'Apache',
                    version: '2.4.41',
                    licesnse: 'Apache 2',
                    lisHref: 'https://www.apache.org/licenses/LICENSE-2.0',
                },
                {
                    name: 'MySQL Server',
                    version: '8.0.28',
                    licesnse: 'GPL2 with modifications',
                    lisHref: 'https://www.gnu.org/licenses/gpl-3.0.en.html'
                },
                {
                    name: 'PHP',
                    version: '7.4.3',
                    licesnse: 'PHP License 3.01',
                    lisHref: 'https://www.php.net/license/3_01.txt'
                },
                {
                    name: 'Wget',
                    version: '3.4.0',
                    licesnse: 'GNU license',
                    lisHref: 'https://www.gnu.org/licenses/gpl-3.0.en.html'
                }
            ],
            heading1: '',
            heading2Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Log in to your instance' } },
                { desc: { 'key': ' Access the WordPress panel using the following URL. <b>http://{IP Address of your WordPress Instance}/wp-admin/</b>' } },
                { desc: { 'key': 'Authenticate with credentials provided in the file <b>/root/.idrive_wordpress_password</b>.<br> <b>Note:</b><br> This Authentication is only for the first time when you initialize WordPress.' } },
                { desc: { 'key': 'Follow the on-screen instructions to create a WordPress user.' } },
                { desc: { 'key': ' Authenticate with the user credentials and start accessing WordPress.' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Note:</b><br> Database and MySQL credentials are stored in <b>/root/.idrive_password</b>'
        }
    },
    {
        key: 'jitsi',
        value: {
            css: 'jitsi',
            name: 'Jitsi Meet',
            version: 'OS ubuntu 20.04',
            heading: 'Jitsi Meet',
            headingDesc: 'Jitsi Meet is a set of Open Source projects for deploying video conferencing solutions. The key features of the video conferencing platform include Screen sharing, live streaming to YouTube, Participant talk-time statistics, and integration with other apps and websites.',
            packages: [
                {
                    name: 'jitsi-server',
                    version: 'Latest',
                    licesnse: 'Apache',
                    lisHref: 'https://github.com/jitsi/jitsi/blob/master/LICENSE',
                },
                {
                    name: 'nginx',
                    version: '1.18.0',
                    licesnse: 'Custom',
                    lisHref: 'http://nginx.org/LICENSE'
                },
                {
                    name: 'gnupg2',
                    version: '2.2.19',
                    licesnse: 'GPL',
                    lisHref: 'https://github.com/isislovecruft/python-gnupg/blob/master/LICENSE'
                }
            ],
            heading01: 'Pre-requisites',
            heading1: '',
            heading2Desc: [],
            heading01Desc: [
                { desc: { 'key': '1. Domain name mapped to your IDrive Compute server IPv4 address.' } },
                { desc: { 'key': '2. Email address.' } }
            ],
            heading1Desc: [
                { desc: { 'key': 'Log in to the instance.' } },
                { desc: { 'key': 'Run bash <b>setup_jitsi.sh</b> to configure your Jitsi server. ' } },
                { desc: { 'key': 'Provide your domain and email address to create HTTPS certificates.' } },
                { desc: { 'key': 'Follow the on-screen instructions to create a WordPress user.' } },
                { desc: { 'key': 'Access your Jitsi server via domain name in your browser. E.g., <b>https://{your domain}</b>.' } },
                { desc: { 'key': 'To reconfigure your Jitsi server, run <b>bash purge_jitsi.sh</b> followed by <b>bash setup_jitsi.sh.</b>' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: 'Learn <a href="https://www.inmotionhosting.com/support/edu/live-broadcasting/jitsi-meet/" target="_blank">how to use Jitsi server</a>.'
        }
    },
    {
        key: 'nakama',
        value: {
            css: 'nakama',
            name: 'Nakama',
            version: 'OS ubuntu 20.04',
            heading: 'Nakama Opensource Game Management Server',
            headingDesc: 'Developed by the Heroic Labs, Nakama is built to be a scalable server for social and real-time games and apps. It lets you add user authentication, social networking, storage, and real-time data exchange into your apps and games. On launching your game or app in the marketplace, handle the additional load by simply launching a few more instances.',
            packages: [
                {
                    name: 'Nakama',
                    version: '3.10.0',
                    licesnse: 'Apache 2',
                    lisHref: 'https://github.com/heroiclabs/nakama/blob/master/LICENSE',
                },
                {
                    name: 'Cockroach',
                    version: '21.2.6',
                    licesnse: 'BSL,CCL',
                    lisHref: 'https://www.cockroachlabs.com/docs/stable/licensing-faqs.html#bsl'
                }
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [],
            heading01Desc: [],
            heading1Desc: [
                { desc: { 'key': 'Access Nakama management console via <b>http://{Ip address of your nakama instance}}: 7351</b>.' } },
                { desc: { 'key': 'Authenticate with the below credentials.<br><b>Username:</b> "admin"<br><b>Password:</b> &lt;stored in the file <b>/root/.idrive_password</b> of your instance&gt;' } },
                { desc: { 'key': 'Once the Nakama server is up and running, it can take up client connections.' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<h2>Get started with your preferred client:</h2><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/unreal/" target="_blank">Unreal client guide</a></p><br><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/unity/" target="_blank">.NET/Unity client guide</a></p><br><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/cpp/" target="_blank">C++ client guide</a></p><br><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/cocos2d-x/" target="_blank">Cocos2d-x client guide - C++</a></p><br><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/cocos2d-js/" target="_blank">Cocos2d-x client guide - JavaScript</a></p><br><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/javascript/" target="_blank">Java/Android client guide</a></p><br><p><a href="https://heroiclabs.com/docs/nakama/client-libraries/swift/" target="_blank">Swift/iOS client guide</a></p>'
        }
    },
    {
        key: 'gitlab',
        value: {
            css: 'gitlab',
            name: 'GitLab',
            version: 'OS ubuntu 20.04',
            heading: 'GitLab Community Edition',
            headingDesc: 'GitLab CE is an open source software development platform written in Ruby. It is used by software developers worldwide to consolidate and deploy code, track versions, and improve code quality.',
            packages: [
                {
                    name: 'gitlab-ce',
                    version: 'Latest',
                    licesnse: 'Custom',
                    lisHref: 'https://docs.gitlab.com/ee/development/licensing.html',
                },
                {
                    name: 'openssh-server',
                    version: '1:8.2p1-4ubuntu0.4',
                    licesnse: 'Public domain',
                    lisHref: ''
                },
                {
                    name: 'net-tools',
                    version: '1.6',
                    licesnse: 'GPL 2.0',
                    lisHref: 'https://www.gnu.org/licenses/old-licenses/gpl-2.0.en.html'
                },
                {
                    name: 'tzdata',
                    version: '2021e-0ubuntu0.20.046',
                    licesnse: 'MIT',
                    lisHref: 'https://github.com/lau/tzdata/blob/master/LICENSE'
                },
                {
                    name: 'ca-certificates',
                    version: '20210119~20.04.2',
                    licesnse: 'GPL 2.0',
                    lisHref: 'https://www.gnu.org/licenses/old-licenses/gpl-2.0.en.html'
                },
                {
                    name: 'perl',
                    version: '5.30.0',
                    licesnse: 'GPL 1.0',
                    lisHref: 'https://dev.perl.org/licenses/gpl1.html'
                }
            ],
            heading01: 'Pre-requisites',
            heading1: '',
            heading2Desc: [],
            heading01Desc: [
                { desc: { 'key': 'Minimum of 4GB of RAMis required to run GitLab.' } },
                { desc: { 'key': 'Refer the <a href="https://docs.gitlab.com/ee/install/requirements.html" target="_blank">official hardware requirements here.</a>' } }
            ],
            heading1Desc: [
                { desc: { 'key': 'Access GitLab by using the IPv4 address of your instance e.g.,<b> http://{IP Address of your gitlab Instance}</b>.' } },
                { desc: { 'key': 'Use the below credentials to authenticate.<br>Username: "root" <br><b>Password:</b> &lt;stored in the file <b>/etc/gitlab/initial_root_password</b> of your instance &gt;. ' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Note:</b><br> GitLab may take 5 minutes for the first time to be up and running.'
        }
    },
    {
        key: 'openlitespeed wordpress',
        value: {
            css: 'openlitespeed',
            name: 'OpenLiteSpeed WordPress',
            version: 'OS ubuntu 20.04',
            heading: 'OpenLiteSpeed WordPress',
            headingDesc: 'OpenLiteSpeed is an easy-to-use, Open Source edition of LiteSpeed Web Server Enterprise. It comes with a powerful cache engine, community support, and unlimited worker processes. OpenLiteSpeed (OLS) comprises all of the essential features, including HTTP/3 support. It delivers enormous scalability and provides an accelerated hosting platform for WordPress.',
            packages: [
                {
                    name: 'OpenLiteSpeed',
                    version: '1.7.16',
                    licesnse: 'GPLv3',
                    lisHref: 'https://www.litespeedtech.com/open-source/openlitespeed',
                },
                {
                    name: 'WordPress',
                    version: '6.0',
                    licesnse: 'GPLv2',
                    lisHref: 'https://wordpress.org/about/license/'
                },
                {
                    name: 'MariaDB',
                    version: '10.6.8',
                    licesnse: 'GPL',
                    lisHref: 'https://mariadb.com/kb/en/mariadb-licenses/'
                },
                {
                    name: 'Certbot',
                    version: '0.40.0',
                    licesnse: 'Apache2',
                    lisHref: 'https://github.com/certbot/certbot/blob/master/LICENSE.txt'
                },
                {
                    name: 'ca-certificates',
                    version: '8.1.6',
                    licesnse: 'Custom',
                    lisHref: ''
                }
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [
            ],
            heading01Desc: [
            ],
            heading1Desc: [
                { desc: { 'key': 'The new WordPress site: <b>http://&lt;Instance Ipv4&gt;</b>' } },
                { desc: { 'key': 'The phpMyAdmin: <b>http://&lt;Instance Ipv4&gt;/phpMyAdmin</b>' } },
                { desc: { 'key': 'Get the MySQL root password and MYSQL WordPress user password with the following command: <b>sudo cat .db_password</b>' } },
                { desc: { 'key': 'Get the admin password for the WebAdmin with the following command: <b>sudo cat .litespeed_password</b>' } }

            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Note:</b><br> OpenLiteSpeed WordPress installation may take <b> 2 to 5 mins </b> based on the system resources.'
        }
    },
    {
        key: 'openlitespeed nodejs',
        value: {
            css: 'openlitespeed',
            name: 'OpenLiteSpeed NodeJS',
            version: 'OS ubuntu 20.04',
            heading: 'OpenLiteSpeed NodeJS',
            headingDesc: 'OpenLiteSpeed Node.js is the Open Source edition of LiteSpeed Web Server Enterprise. An easy-to-use, lightweight app that automatically installs OpenLiteSpeed and Node.js, comprises the essential features, including HTTP/3 support. OLS can host multiple Node.js apps and support other apps such as Ruby, Python, and CMSs like WordPress.',
            packages: [
                {
                    name: 'OpenLiteSpeed',
                    version: '1.7.16',
                    licesnse: 'GPLv3',
                    lisHref: 'https://www.litespeedtech.com/open-source/openlitespeed',
                },
                {
                    name: 'Certbot',
                    version: '0.40.0',
                    licesnse: 'Apache2',
                    lisHref: 'https://github.com/certbot/certbot/blob/master/LICENSE.txt'
                },
                {
                    name: 'NodeJS',
                    version: '10.19.0',
                    licesnse: 'Custom',
                    lisHref: 'https://github.com/nodejs/node/blob/master/LICENSE'
                }
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [
            ],
            heading01Desc: [
            ],
            heading1Desc: [
                { desc: { 'key': 'The sample node can be viewed at <b>http://&lt;Instance Ipv4&gt;</b>' } },
                { desc: { 'key': 'OpenLiteSpeed Web console can be accessed at port 7080 , e.g. <b>http://&lt;Instance Ipv4&gt;:7080</b>' } },
                { desc: { 'key': 'Get the admin password for the WebAdmin with the following command: <b>sudo cat. litespeed_password</b>' } }

            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Note:</b><br> OpenLiteSpeed NodeJS installation may take <b> 2 to 5 mins </b> based on the system resources.'
        }
    },
    {
        key: 'cloudron',
        value: {
            css: 'openlitespeed',
            name: 'Cloudron',
            version: 'OS ubuntu 20.04',
            heading: 'Cloudron',
            headingDesc: 'Cloudron is a single-click platform that provides you a centralized way to install, secure web apps on your server, and manage your users and their web apps from anywhere. Its 60+ applications have been tested and approved to run smoothly. Cloudron automates all the tasks from configuring databases, setting DNS records to managing certificates.',
            packages: [
                {
                    name: 'Cloudron',
                    version: 'latest',
                    licesnse: 'Proprietary',
                    lisHref: 'https://www.cloudron.io/legal/license.html',
                }
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [
            ],
            heading01Desc: [
            ],
            heading1Desc: [
                { desc: { 'key': 'Open a URL <b>http://&lt;Cloudron Instance IPv4&gt;</b> in your browser.' } },
                { desc: { 'key': 'Enter a domain like <b>example.com</b>.Cloudron\'s admin interface will then be available at <b>my.example.com </b>and apps can be installed into subdomains like <b>blog.example.com</b>, <b>git.example.com</b>. Post - installation, more domains can be added.' } },
                { desc: { 'key': 'Click \'Next\', Cloudron will automatically configure the DNS, set up certificates, and redirect you to <b>my.example.com</b>.' } },
                { desc: { 'key': 'Now, set up a Cloudron administrator and start using Cloudron!.' } }

            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Note:</b> Cloudron installation takes <b>10-15 minutes</b> once the Instance is provisioned, and it will be rebooted upon completion.'
        }
    },
    {
        key: 'cyberpanel',
        value: {
            css: 'cyberpanel',
            name: 'CyberPanel',
            version: 'OS ubuntu 20.04',
            heading: 'CyberPanel',
            headingDesc: 'CyberPanel is a one-click server control panel that allows you to create virtual servers via LiteSpeed Web Server. This hosting control panel can be used for website creation, SSL certificate installation, DNS and email management, and more. CyperPanel image features a single-click installer for automatic installation of common frameworks like OpenLiteSpeed, WordPress, LSCache, Joomla, Prestashop, git, and Magento. It also automatically sets up DNS and Email service thereby reducing the duration required for configuration.',
            packages: [
                {
                    name: 'CyberPanel',
                    version: 'latest',
                    licesnse: 'GPLv3',
                    lisHref: 'https://github.com/usmannasir/cyberpanel/blob/v2.0.0/LICENSE',
                },
                {
                    name: 'OpenLiteSpeed',
                    version: 'latest',
                    licesnse: 'GPLv3',
                    lisHref: 'https://www.litespeedtech.com/open-source/openlitespeed',
                },
                {
                    name: 'PHP',
                    version: '7.4.29',
                    licesnse: 'Proprietary',
                    lisHref: '',
                },
                {
                    name: 'Rainloop',
                    version: 'latest',
                    licesnse: 'AGPLv3',
                    lisHref: 'https://www.rainloop.net/licensing/',
                },
                {
                    name: 'PowerDNS',
                    version: '4.2.1',
                    licesnse: 'GPLv2',
                    lisHref: 'https://github.com/PowerDNS/pdns/blob/master/COPYING',
                }
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [
            ],
            heading01Desc: [
            ],
            heading1Desc: [
                { desc: { 'key': '<span class="p_hd">Open the web browser to view the following:</span><span class="p_li"><i>CyberPanel:</i><b class="link_bld"> https://&lt;Instance IPv4&gt;:8090</b></span><span class="p_li"><i>phpMyAdmin:</i>  <b class="link_bld"> https://&lt;Instance IPv4&gt;:8090/dataBases/phpMyAdmin</b></span><span class="p_li"><i>Rainloop:</i>  <b class="link_bld"> https://&lt;Instance IPv4&gt;:8090/rainloop</b></span>' } },
                { desc: { 'key': 'Get the CyberPanel admin password with the following command: <b> sudo cat .idrive_password </b> ' } },
                { desc: { 'key': 'Get the MySQL CyberPaner user password with the following command: <b> sudo cat .litespeed_password</b> ' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Notes:</b> <br>- CyberPanel installation takes <b>12-15 minutes</b> once the Instance is provisioned.<br>- CyberPanel has to be authenticated before accessing phpMyAdmin.<br>- CyberPanel configuration is required for accessing Rainloop Webmail. Learn <a href="https://community.cyberpanel.net/t/how-to-access-rainloop-webmail-in-cyberpanel/30640" target="_blank">how to access Rainloop Webmail in Cyberpanel</a>'
        }
    },
    {
        key: 'openlitespeed joomla',
        value: {
            css: 'openlitespeed',
            name: 'OpenLiteSpeed Joomla',
            version: 'OS ubuntu 20.04',
            heading: 'OpenLiteSpeed Joomla',
            headingDesc: 'Joomla is a Content Management System (CMS) that enables you to build and manage websites and online applications. It is a simple and powerful web server application that requires a server with PHP and either MySQL or PostgreSQL to run. It is free and open source software distributed under the GNU General Public License version 2 or later.',
            packages: [
                {
                    name: 'PHP',
                    version: '8.0.21',
                    licesnse: 'Proprietary',
                    lisHref: '',
                },
                {
                    name: 'Joomla',
                    version: '1.7.16',
                    licesnse: 'GPLv2',
                    lisHref: 'https://www.gnu.org/licenses/old-licenses/gpl-2.0.html',
                },
                {
                    name: 'Maria DB',
                    version: '10.6.8',
                    licesnse: 'GPL',
                    lisHref: 'https://mariadb.com/kb/en/mariadb-licenses/',
                },
                {
                    name: 'OpenLiteSpeed',
                    version: '1.7.16',
                    licesnse: 'GPLv3',
                    lisHref: 'https://www.litespeedtech.com/open-source/openlitespeed',
                },
                {
                    name: 'Certbot',
                    version: '4.0.21',
                    licesnse: 'Apache2',
                    lisHref: 'https://github.com/certbot/certbot/blob/master/LICENSE.txt'
                },
                {
                    name: 'Postfix',
                    version: '3.4.13',
                    licesnse: 'IBM PL 1.0',
                    lisHref: 'http://www.postfix.org/IBM-Public-License-1.0.txt'
                },
                {
                    name: 'phpMyAdmin',
                    version: '4.9.5',
                    licesnse: 'GPLv2',
                    lisHref: 'https://www.phpmyadmin.net/license/'
                }
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [
            ],
            heading01Desc: [
            ],
            heading1Desc: [
                { desc: { 'key': '<span class="p_hd">In a web browser, you can view:</span><span class="p_li">Joomla site: <b>https://&lt;Instance IPv4&gt;</b></span><span class="p_li">phpMyAdmin: <b>https://&lt;Instance IPv4&gt;/phpMyAdmin</b></span>' } },
                { desc: { 'key': 'The default web root is located at: <b>/var/www/html</b>' } },
                { desc: { 'key': 'Get the MySQL root password and MySQL Joomla user password with command: <b>sudo cat .db_password</b>' } },
                { desc: { 'key': 'Get the Web Admin admin password with the following command: <b>sudo cat .litespeed_password</b>' } },
                { desc: { 'key': 'The phpMyAdmin is located at: <b>/var/www/phpmyadmin</b>' } }
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: ''
        }
    },
    {
        key: 'rancheros',
        value: {
            css: 'rancheros',
            name: 'RancherOS',
            version: 'RancherOS-1.5.8-x86_64',
            heading: 'RancherOS',
            headingDesc: 'Rancher OS is smaller than many traditional Linux operating system distributions as it uses only the necessary libraries and services to deploy and scale containers. Run by Rancher Labs, all processes in this OS are container managed by Docker. This open source OS includes system services such as udev and syslog. Removal of unnecessary libraries and services reduces requirements for security patches and other maintenance. Docker allows users to package all necessary libraries into their containers.<br><br>For information on running the Rancher server on Rancher OS, visit the following link:<br><br><a href="https://rancher.com/docs/rancher/v1.6/en/installing-rancher/installing-server/" target="_blank">https://rancher.com/docs/rancher/v1.6/en/installing-rancher/installing-server/</a>',
            packages: [
            ],
            heading01: '',
            heading1: '',
            heading2Desc: [
            ],
            heading01Desc: [
            ],
            heading1Desc: [
            ],
            heading3: '',
            heading3Desc: [],
            restInfo: '<b>Notes:</b> <br>- Enter the username rancher to login to your instance.<br>&nbsp;&nbsp;E.g.: <b>ssh rancher@&lt;rancher_instance_Ipv4&gt;</b><br>- Only SSH form of authentication is supported.'
        }
    }
];
